import React from "react";
import { CardTitle } from "reactstrap";
import { Icon, TooltipComponent } from "../../../Component";
import { BarChart } from "../../charts/sales/Charts";

const SaleRevenue = ({ data, chart, title, caption }) => {
  return (
    <React.Fragment>
      <div className="card-title-group align-start mb-2">
        <CardTitle>
          <h6 className="title">{title ?? "Activities"}</h6>
          <p className="text-soft small mb-0">{caption ?? data?.[0]?.title ?? ""}</p>
        </CardTitle>
        <div className="card-tools">
          <TooltipComponent
            icon="help-fill"
            iconClass="card-hint"
            direction="left"
            id="tooltip-1"
            text="User activities in last 30 days"
          />
        </div>
      </div>
      <div className="align-end gy-3 gx-5 flex-wrap flex-md-nowrap flex-lg-wrap flex-xxl-nowrap">
        <div className="nk-sale-data-group flex-md-nowrap g-4">
         {data?.map((item,index)=>(
           <div className="nk-sale-data">
            <span className="amount">
              {item?.count||0}{" "}
              <span className={`${item?.trend=="up" ? "change up text-success":  "change down text-danger"}`}>
                <Icon name={`${item?.trend=="up"? "arrow-long-up":"arrow-long-down"} `} />
                {item?.precent}
              </span>
            </span>
            <span className="sub-title">{item?.title}</span>
          </div>
         ))}
         
        </div>
        <div className="nk-sales-ck sales-revenue">
          <BarChart data={chart} />
        </div>
      </div>
    </React.Fragment>
  );
};
export default SaleRevenue;
